<template>
  <div id="app">
    <!--<NavigationBar/>-->
    <Swiper class="margin-t-20"/>
    <AboutBusiness class="margin-t-120"/>
    <NewTopics class="margin-tb-50"/>
    <AboutSystem/>
    <PriceList class="margin-tb-50"/>
    <CustomerVoice/>
    <ToFC class="margin-tb-50"/>
    <!--<Footer/>-->
  </div>
</template>

<script>
//import NavigationBar from '../../components/NavigationBar.vue'
import Swiper from './TopSwiper.vue'
import AboutBusiness from './AboutBusiness.vue'
import NewTopics from './NewTopics.vue'
import AboutSystem from './AboutSystem.vue'
import PriceList from './PriceList.vue'
import CustomerVoice from './CustomerVoice'
import ToFC from '../../components/ToFC.vue'
//import Footer from '../../components/Footer'

export default {
  name: 'app',
  components: {
    //NavigationBar,
    Swiper,
    AboutBusiness,
    NewTopics,
    AboutSystem,
    PriceList,
    CustomerVoice,
    ToFC,
    //Footer,
  }
}
</script>


<style scoped>
  @import "../../css/style.css";

  .margin-tb-50{
    margin: 50px auto;
  }

  .margin-tb-30{
    margin: 30px auto;
  }

  .margin-t-20{
    margin: 20px auto;
  }

  .margin-t-120{
    margin-top: 10vw;
  }
</style>